export default "__VITE_ASSET__eC4OkAVe__"